import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Paper,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import { AdminActions } from "../../redux/actions/AdminActions";
import { history } from "../helpers/History";
import { USER_ROLE } from "../security/UserRole";
import { AppConstants } from "../constants/ApplicationConstants";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    padding: theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  root: {
    width: "100%"
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class DynamicForm extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
        name: this.props.name?this.props.name:'',
        type: this.props.type?this.props.type:'',
        options: this.props.options?this.props.options:'',
        index: this.props.index?this.props.index:0,
        label:this.props.label?this.props.label:'',
    };
  }
  
  componentDidUpdate(prevProps){
    if (this.state.name != this.props.name){
       this.setState({name:this.props.name});
    }
    if (this.state.type != this.props.type){
      this.setState({type:this.props.type});
   }
   if (this.state.options != this.props.options){
    this.setState({options:this.props.options});
   }
   if (this.state.index != this.props.index){
      this.setState({index:this.props.index});
   }
   if (this.state.label != this.props.label){
    this.setState({label:this.props.label});
   }
  }

  render() {
    const classes = this.props.classes;
    return (
      
        <Card className={classes.root} key={this.props.key}>
          <CardHeader
            action={
              <IconButton color="secondary" onClick={()=>{
                this.props.handleRemoveFormFields(this.props.index);
              }}>
                <CancelIcon />
              </IconButton>
            }
          />
          <CardContent>
                <form
                  className={classes.form}
                  name="form"
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        label="Name"
                        margin="normal"
                        name="name"
                        onChange={(e) => {
                          this.setState({name:e.target.value})
                          this.props.handleChange(this.props.index,'name',e.target.value);
                        }}
                        value={this.state.name}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        fullWidth
                        label="Label"
                        margin="normal"
                        name="label"
                        onChange={(e) => {
                          this.setState({label:e.target.value})
                          this.props.handleChange(this.props.index,'label',e.target.value);
                        }}
                        value={this.state.label}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl
                        variant="outlined"
                        margin="normal"
                        className={classes.formControl}
                        fullWidth
                      >
                        <InputLabel htmlFor="type-label">Type</InputLabel>
                        <Select
                          native
                          value={this.state.type}
                          label="Type"
                          inputProps={{
                            name: "type",
                            id: "type-label",
                          }}
                          onChange={(e) => {
                            this.setState({type:e.target.value})
                            this.props.handleChange(this.props.index,'type',e.target.value);
                          }}
                        >
                          <option value="Text">Text</option>
                          <option value="CheckBox">CheckBox</option>
                          <option value="Select">Select</option>
                          <option value="Date">Date</option>
                          <option value="DateTime">DateTime</option>
                          <option value="MultiSelect">MultiSelect</option>
                          <option value="Radio">Radio</option>
                        </Select>
                      </FormControl>
                    </Grid>
                    {(this.state.type=="Select" || this.state.type=="Radio" || this.state.type=="MultiSelect") ?
                    <Grid item xs={12} sm={12}>
                      <TextField
                        fullWidth
                        label="Options | Please use ~ for different options"
                        margin="normal"
                        name="options"
                        multiline
                        rows={4}
                        onChange={(e) => {
                            this.setState({options:e.target.value})
                            this.props.handleChange(this.props.index,'options',e.target.value);
                        }}
                        value={this.state.options}
                        variant="outlined"
                      />
                    </Grid>: null}

                    
                  </Grid>
                </form>
             
          </CardContent>
        </Card>
      
    );
  }
}

function mapStateToProps(state) {
  const { registration } = state.registration;
  return { registration };
}

const mapDispatchToProps = (dispatch) => {
  return {
    submit: (value) => {
      console.log(value);
      //dispatch(AdminActions.registerAdmin(value));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(DynamicForm));
